<template>
	<card class="card-default mt-4">
		<card-header class="d-flex">
            <b>{{ webchat.name }}</b>
			<div class="ml-auto">
                <span class="font-weight-bold text-muted mr-1 small">
                    Sort by:
                </span>

                <ul class="dropdown rounded d-inline-block position-relative">
                    <li role="button"
                        class="py-1 pl-1 pr-2 font-weight-bold d-flex
                            align-items-center justify-content-between dropdown__selected"
                        @click="expanded = !expanded">
                        {{ sort_by }}

                        <i class="fas fa-sort-down"></i>
                    </li>

                    <li class="dropdown__list-container position-absolute" v-if="expanded">
                        <ul class="bg-white rounded dropdown__list">
                            <li role="button" class="p-2 dropdown__list-item" @click="selectPeriod('Today')">
                                Today
                            </li>
                            <li role="button" class="p-2 dropdown__list-item" @click="selectPeriod('This Week')">
                                This Week
                            </li>
                            <li role="button" class="p-2 dropdown__list-item" @click="selectPeriod('This Month')">
                                This Month
                            </li>
                            <li role="button" class="p-2 dropdown__list-item" @click="selectPeriod('All Time')">
                                All Time
                            </li>
                        </ul>
                    </li>
                </ul>
                <button class="btn btn-default btn-sm btn-icon ml-1" title="Delete" @click="remove">
                    <i class="fa fa-fw fa-trash"></i>
                </button>
				<a class="btn btn-default btn-sm btn-icon ml-1" title="Edit" :href="editUrl">
                    <i class="fa fa-fw fa-pencil-alt"></i>
                </a>
			</div>
		</card-header>
		<card-body class="pt-0">
            <div class="row">
                <div class="col-3">
                    <div class="d-flex align-items-center justify-content-center circle total__locations"
                        :class="{'total__locations-present': countLocations}">
                        <div class="total__locations__text">
                            {{ countLocations }}
                        </div>
                    </div>
                    <p class="text-center my-2 font-weight-bold">
                        {{ textLocations }}
                    </p>
                </div>

                <div class="col-3">
                    <card-spinner v-if="loading" style="height: 90px;"/>
                    <div v-if="!loading" class="d-flex align-items-center justify-content-center circle">
                        <div class="text-white">
                            {{ totalOpened }}
                        </div>
                    </div>
                    <p class="text-center my-2">
                        Opened
                    </p>
                </div>

                <div class="col-3">
                    <card-spinner v-if="loading" style="height: 90px;"/>
                    <div v-if="!loading" class="d-flex align-items-center justify-content-center circle">
                        <div class="text-white">{{ totalConversions }}</div>
                    </div>
                    <p class="text-center my-2">
                        Conversions
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class=" mt-3">
                        <a :href="'/webchat/test/' + webchat.id" class="btn btn-primary"><i class="fas fa-laptop-code pr-1"></i>Test Widget</a>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="text-right mt-4">
                        <a class="text-primary cursor-pointer" @click="showScript = !showScript">
                            <span v-if="!showScript">Show Script<i class="fa fa-angle-down ml-2"></i></span>
                            <span v-if="showScript">Hide Script<i class="fa fa-angle-up ml-2"></i></span>
                        </a>
                    </div>
                </div>
            </div>

			<transition name="fade">
				<div class="mt-3" v-if="showScript">
                    <div>
                        <label>Insert this script in your website before close tag &lt;/body&gt;</label>
                        <div style="border-radius:4px;background-color:#2A2A2A;color:lightgray;border:1px gray solid;padding:8px;">
                            {{ webChatScript }}
                        </div>
                    </div>
				</div>
			</transition>
		</card-body>
	</card>
</template>

<script>
export default {
    props: ['webchat'],

    data() {
        return {
            loading: false,
            conversions: this.webchat.total_messages,
            opened: this.webchat.total_opened,
            expanded: false,
            sort_by: 'All Time',
            showScript: false
        }
    },

    computed: {
        totalSteps() {
            return this.countLocations === 0 ? 1 : this.countLocations;
        },

        countLocations() {
            return this.webchat.locations.length;
        },

        textLocations() {
            return this.countLocations <= 1 ? 'Location' : 'Locations';
        },

        totalOpened() {
            return this.opened;
        },

        totalConversions() {
            let value = this.conversions;

            if (value >= 1000) {
                value = parseFloat(value / 1000).toFixed(1);
                value = Math.round(value * 10) / 10;

                return `${value}k`;
            }

            return value;
        },

        editUrl() {
            return this.$laroute.route('webchat.edit', {webchat: this.webchat.id});
        },

        defaultUrl() {
            return `${window.location.origin}/widget/js/chat.js#`;
        },

        webChatScript() {
            let script = document.createElement('script');
            script.text = `(function(){var w=window;var d=document;var l=function(){var s=d.createElement('script');` +
                `s.type='text/javascript';s.async=true;s.src="${this.defaultUrl}${this.webchat.token}";` +
                `s.setAttribute('data-api-token','${this.webchat.token}');` +
                `var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};` +
                `if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}})();`

            return script.outerHTML;
        }
    },

    methods: {
        remove() {
            this.$confirm().then(() => {
                const url = this.$laroute.route('webchat.destroy', { webchat: this.webchat.id });
                this.$http.delete(url)
                    .then(res => {
                        const message = res.data.message;
                        this.$alert({
                            message,
                            type: 'success',
                            title: 'Success!'
                        });
                        this.$emit('deleted');
                    })
                    .catch(err => console.log('err from delete', err))
            });
        },

        async selectPeriod(period) {
            this.expanded = false;
            this.sort_by = period;
            this.loading = true;
            await this.$http.get(this.$laroute.route('webchat.sort-by', { webchat: this.webchat.id, period: period }))
                .then(({data}) => {
                    this.opened = data.opened;
                    this.conversions = data.conversions;
                    this.loading = false;
                })
        }
    }
}
</script>

<style lang="scss" scoped>
    .dropdown,
    .dropdown__list {
        padding: 0;
        list-style: none;
    }

    .dropdown {
        min-width: 130px;
        font-size: .9rem;
        box-shadow: 0 2px 3px rgba(55, 63, 67, .16);
    }

    .dropdown__selected {
        color: #0374d7;
    }

    .dropdown__list-container {
        min-width: 120px;
        right: 0;
    }

    .dropdown__list {
        box-shadow: 0 2px 3px rgba(55, 63, 67, .16);
    }

    .dropdown__list-item {
        &:hover {
            color: #0374d7;
        }
    }

    .circle {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        margin: auto;

        &:not(.total__locations) {
            background-color: #0374d7;
            font-size: 1.8rem;
        }
    }

    .total__locations {
        border: 5px solid #edf0f2;

        &.total__locations-present {
            border-color: #0374d7;
        }
    }

    .total__locations__text {
        font-size: 2.5rem;
        color: #0374d7;
    }
</style>

